import get from 'lodash/get';

export default {
    created() {
        if (this.$page && this.$page.props.models) {
            this.$page.props.models.forEach(async ({ entity, key }) => {
                const modelClass = this.$store.$db().model(entity);
                const model = get(this.$page.props, key);

                if (model) {
                    await modelClass.insert({ data: model });
                }
            });
        }
    },
};
